import React, { useState, useEffect } from "react";
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useObjectStore } from "../zustand/objects";
import { Box } from "@mui/material/";
import { Button, Menu, Group, ActionIcon, rem, useMantineTheme } from '@mantine/core';

import HardwareOutlinedIcon from '@mui/icons-material/HardwareOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';

import { TemplateModal } from "./TemplateModal";

export const TemplateDropdown = ({ projectKey, iconColour }) => {

  const [category, setCategory] = useState(null)
  const [open, setOpen] = useState(false)
  const [hover, setHover] = useState(false)

  const handleSelect = (data) => {
    setCategory(data.value)
    setOpen(true)
  }


  const categories = [
    { value: 'Construction', label: 'Construction template' },
    { value: 'Education', label: 'Education template' },
    { value: 'Home', label: 'Home template' },
    { value: 'Medical', label: 'Medical template' },
    { value: 'Menu', label: 'Menu template' },
    { value: 'Office', label: 'Office template' },
  ]

  const closeModal = () => {
    setOpen(false)
  }

  return (
    <>
        <Menu transitionProps={{ transition: 'pop' }} withinPortal trigger="click-hover">
          <Menu.Target>
            <ActionIcon
              variant="transparent"
              color={!hover ? iconColour.normal : iconColour.hover}
              onPointerOver={() => setHover(true)}
              onPointerLeave={() => setHover(false)}
            >
              <DashboardIcon
                variant="transparent"
                color={'black'}
                fontSize={'small'}
              />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item value="Construction" onClick={() => handleSelect(categories[0])} leftSection={<HardwareOutlinedIcon fontSize={'small'} />}>Construction templates</Menu.Item>
            <Menu.Item value="Education" onClick={() => handleSelect(categories[1])} leftSection={<ScienceOutlinedIcon fontSize={'small'} />}>Education templates</Menu.Item>
            <Menu.Item value="Home" onClick={() => handleSelect(categories[2])} leftSection={<HomeOutlinedIcon fontSize={'small'} />}>Home templates</Menu.Item>
            <Menu.Item value="Medical" onClick={() => handleSelect(categories[3])} leftSection={<MedicalServicesOutlinedIcon fontSize={'small'} />}>Medical templates</Menu.Item>
            <Menu.Item value="Menu" onClick={() => handleSelect(categories[4])} leftSection={<WidgetsOutlinedIcon fontSize={'small'} />}>Menu templates</Menu.Item>
            <Menu.Item value="Office" onClick={() => handleSelect(categories[5])} leftSection={<LocalPrintshopOutlinedIcon fontSize={'small'} />}>Office templates</Menu.Item>

          </Menu.Dropdown>
        </Menu>
      <TemplateModal projectKey={projectKey} category={category} open={open} close={closeModal} />
    </>
  );
};





